import { createFileRoute } from "@tanstack/react-router";
import FaraComision from "@/pages/produs/FaraComision";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/fara-comision/")({
  head: () => routeHead("/fara-comision/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <FaraComision />
  );
}
